/* ShadowsDeal menu + drawer navigation */
(function(){
  'use strict';
  if(window.__shadowsMenuDrawerV2)return;
  window.__shadowsMenuDrawerV2=true;
  var BREAKPOINT=1040;
  function all(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function reduced(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;}
  function drawIcons(){if(window.lucide){try{window.lucide.createIcons({attrs:{'stroke-width':1.8}});}catch(e){}}}
  function init(){
    var header=document.querySelector('[data-sd-nav2]');
    var drawer=document.querySelector('[data-sd-nav2-drawer]');
    if(!header||!drawer||header.dataset.sdNav2Ready==='1')return;
    header.dataset.sdNav2Ready='1';
    var openButton=header.querySelector('[data-sd-nav2-open]');
    var panel=drawer.querySelector('.sd-nav2-drawer__panel');
    var closeButtons=all('[data-sd-nav2-close]',drawer);
    var accordionButtons=all('[data-sd-nav2-accordion]',drawer);
    var desktopItems=all('[data-sd-nav2-desktop-item]',header);
    var desktopButtons=all('[data-sd-nav2-desktop-toggle]',header);
    var previousFocus=null;
    function mobile(){return window.innerWidth<=BREAKPOINT;}
    function closeAccordions(except){
      accordionButtons.forEach(function(button){
        var item=button.closest('[data-sd-nav2-drawer-item]');
        if(item===except)return;
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded','false');
      });
    }
    function closeDesktop(except){
      desktopItems.forEach(function(item){
        if(item===except)return;
        item.classList.remove('is-open');
        var button=item.querySelector('[data-sd-nav2-desktop-toggle]');
        if(button)button.setAttribute('aria-expanded','false');
      });
    }
    function openDrawer(){
      if(!mobile())return;
      previousFocus=document.activeElement;
      drawer.hidden=false;
      document.body.classList.add('sd-nav2-open');
      openButton.setAttribute('aria-expanded','true');
      requestAnimationFrame(function(){
        drawer.classList.add('is-open');
        var target=drawer.querySelector('[data-sd-nav2-close]');
        if(target)target.focus();
      });
    }
    function closeDrawer(returnFocus){
      drawer.classList.remove('is-open');
      document.body.classList.remove('sd-nav2-open');
      openButton.setAttribute('aria-expanded','false');
      closeAccordions();
      window.setTimeout(function(){
        drawer.hidden=true;
        if(returnFocus!==false&&previousFocus&&previousFocus.focus)previousFocus.focus();
      },reduced()?0:230);
    }
    if(openButton)openButton.addEventListener('click',openDrawer);
    closeButtons.forEach(function(button){button.addEventListener('click',function(){closeDrawer(true);});});
    accordionButtons.forEach(function(button){
      button.addEventListener('click',function(){
        var item=button.closest('[data-sd-nav2-drawer-item]');
        if(!item)return;
        var next=!item.classList.contains('is-open');
        closeAccordions(next?item:null);
        item.classList.toggle('is-open',next);
        button.setAttribute('aria-expanded',String(next));
      });
    });
    desktopButtons.forEach(function(button){
      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var item=button.closest('[data-sd-nav2-desktop-item]');
        if(!item)return;
        var next=!item.classList.contains('is-open');
        closeDesktop(next?item:null);
        item.classList.toggle('is-open',next);
        button.setAttribute('aria-expanded',String(next));
      });
    });
    drawer.addEventListener('click',function(event){
      var link=event.target.closest('a[href]');
      if(link)closeDrawer(false);
    });
    document.addEventListener('click',function(event){
      if(!header.contains(event.target))closeDesktop();
    });
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'){
        if(!drawer.hidden){event.preventDefault();closeDrawer(true);return;}
        var openDesktop=header.querySelector('[data-sd-nav2-desktop-item].is-open');
        if(openDesktop){
          var button=openDesktop.querySelector('[data-sd-nav2-desktop-toggle]');
          openDesktop.classList.remove('is-open');
          if(button){button.setAttribute('aria-expanded','false');button.focus();}
        }
        return;
      }
      if(event.key==='Tab'&&!drawer.hidden&&drawer.classList.contains('is-open')){
        var focusables=all('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',panel).filter(function(node){return node.offsetParent!==null;});
        if(!focusables.length)return;
        var first=focusables[0],last=focusables[focusables.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
    var wasMobile=mobile();
    window.addEventListener('resize',function(){
      var nowMobile=mobile();
      if(nowMobile!==wasMobile){
        wasMobile=nowMobile;
        if(!drawer.hidden)closeDrawer(false);
        closeDesktop();
      }
    },{passive:true});
    drawIcons();
    window.setTimeout(drawIcons,200);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',function(){window.__shadowsMenuDrawerV2=false;init();});
})();
